import React from 'react';
import { Box, Flex } from '@components/layout/Grid';
import {
  H2SectionHeader,
  SubTitle,
  sectionTitleStyle,
} from '@components/texts';
import styled, {
  DefaultTheme,
  FlattenInterpolation,
  ThemeProps,
} from 'styled-components';

const Header = styled(H2SectionHeader)`
  ${sectionTitleStyle}
`;

type Props = {
  className?: string;
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  subTitleStyle?: FlattenInterpolation<ThemeProps<DefaultTheme>> | string;
  secondSubtitle?: React.ReactNode;
  button?: React.ReactNode;
};

const SectionHeader = (props: Props) => (
  <React.Fragment>
    <Flex
      className={props.className}
      justifyContent="space-between"
      alignItems="center"
    >
      <Box>
        <Header className="SectionHeader--H2SectionHeader">
          {props.title}
        </Header>
        {props.subTitle && (
          <SubTitle
            {...(props.subTitleStyle
              ? { customStyle: props.subTitleStyle }
              : {})}
          >
            {props.subTitle}
          </SubTitle>
        )}
        {props.secondSubtitle && <SubTitle>{props.secondSubtitle}</SubTitle>}
      </Box>
      {props.button ? (
        <Box flexShrink={0} ml={[40, 40, 0]}>
          {props.button}
        </Box>
      ) : null}
    </Flex>
  </React.Fragment>
);

export default SectionHeader;
